import { Box, Drawer } from "@mui/material";
import { DetailCloseIcon } from "../../../assets/icons/icon";
import { LanguageContext } from "../../../context/LanguageContext";
import { ParagraphText } from "../../../Libraries";
import { useContext } from "react";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const UBRightSidebar = ({
  id = "",
  title,
  open,
  onClose,
  children,
  customeHeader,
  footerLeft,
  footerRight,
}) => {
  const [I18n] = useContext(LanguageContext);
  const hasFooter = footerLeft != null || footerRight != null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {
        triggerLogEvent(analytics, "sidebar_closed", { sidebar_id: id });
        onClose(false);
      }}
      className={`${styles.wrapper} UBRightSidebarWrapper`}
      PaperProps={{
        sx: {
          boxShadow: "none !important",
        },
      }}
    >
      {customeHeader ? (
        customeHeader
      ) : (
        <Box className={`${styles.header} UBRightSidebarHeader`}>
          <Box className={`${styles.headerLeft} UBRightSidebarHeaderLeft`}>
            <ParagraphText
              className="newFontColor fontSize16 fontWeight400"
              id={`${id}_heading`}
            >
              {I18n[title] || title}
            </ParagraphText>
          </Box>
          <Box className="UBRightSidebarHeaderRight">
            <ParagraphText
              id={`${id}_close`}
              className={`${styles.closeIcon} UBRightSidebarCloseIcon`}
              onClick={() => {
                triggerLogEvent(analytics, "sidebar_closed", { sidebar_id: id });
                onClose(false);
              }}
            >
              <DetailCloseIcon />
            </ParagraphText>
          </Box>
        </Box>
      )}
      <Box className={`${styles.body} UBRightSidebarBody`}>{children}</Box>
      {hasFooter && (
        <Box className={styles.footerBox}>
          <Box className={styles.footerLeft}>{footerLeft}</Box>
          <Box className={styles.footerRight}>{footerRight}</Box>
        </Box>
      )}
    </Drawer>
  );
};

export default UBRightSidebar;
